import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const CanonicalURLIcon = ({width, height, fill, ...rest}) => {
  return (
    <SvgIcon width={width || "24px"} height={height || '24px'} fill={fill || 'surface.contrastText'} {...rest}>
      <path d="M6 2c-1.103 0-2 .897-2 2v16c0 1.103.897 2 2 2h5.102a5.033 5.033 0 0 1 0-2H6V4h7v5h5v3.027a4.957 4.957 0 0 1 2-.92V8l-6-6H6zm15 11c-.768 0-1.536.294-2.121.879l-1.473 1.47 1.414 1.417-2.111 2.111 1.414 1.412 2.125-2.125-1.414-1.412 1.459-1.459a1 1 0 0 1 1.707.705.993.993 0 0 1-.293.707l-1.445 1.447 1.414 1.414 1.445-1.445A2.984 2.984 0 0 0 24 15.998c0-.801-.312-1.553-.879-2.12A2.992 2.992 0 0 0 21 13zm-4.291 5.877-1.414-1.414-1.416 1.416A2.98 2.98 0 0 0 13 21c0 .801.312 1.554.879 2.121.566.567 1.32.879 2.121.879a2.98 2.98 0 0 0 2.121-.879l1.416-1.416-1.414-1.414-1.416 1.416a1.022 1.022 0 0 1-1.414 0A.993.993 0 0 1 15 21c0-.268.104-.518.293-.707l1.416-1.416z" />
    </SvgIcon>
  )
}

export default CanonicalURLIcon;
